/**
 * What browsers say when a script module cannot be fetched: Chromium, Firefox, and WebKit
 * for a failed `import()`, and Vite's preload helper for a page's stylesheet.
 */
const CODE_LOAD_FAILURES = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS/i,
];

/**
 * True when part of the app's own code could not be loaded: a newer version replaced it on
 * the server after this page was opened (hosts delete the previous version's files), or the
 * connection dropped. Reloading loads the current version; nothing is reloaded on its own,
 * so a broken deployment cannot cause a reload loop.
 */
export function isCodeLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return CODE_LOAD_FAILURES.some((failure) => failure.test(message));
}
